module.exports = __webpack_public_path__ + "5f72df4db47caaee585f77517b82ba20.png";